
/* injects from baggage-loader */

/*
Copyright (c) 2003-2015, CKSource - Frederico Knabben. All rights reserved.
For licensing, see LICENSE.md or http://ckeditor.com/license
*/
CKEDITOR.plugins.setLang( 'colortext', 'ja', {
  auto: '自動的に',
  bgColorTitle: '背景色',
  colors: {
    '000': 'ブラック',
    '800000': 'あずき色',
    '8B4513': 'レザーブラウン',
    '2F4F4F': 'ダークスレートグレー',
    '008080': '青緑色',
    '000080': '紺',
    '4B0082': 'インジゴ',
    '696969': '濃い灰色',
    'B22222': 'レンガ',
    'A52A2A': '褐色',
    'DAA520': 'ゴールデンバーチ',
    '006400': '濃い緑色',
    '40E0D0': 'ターコイズ',
    '0000CD': 'ミディアムブルー',
    '800080': '紫の',
    '808080': 'グレー',
    'F00': '赤',
    'FF8C00': 'ダークオレンジ',
    'FFD700': 'ゴールド',
    '008000': '緑',
    '0FF': 'ヤグルマギク',
    '00F': '青い',
    'EE82EE': 'バイオレット',
    'A9A9A9': '薄暗い灰色',
    'FFA07A': 'ライトサーモン',
    'FFA500': 'オレンジ',
    'FFFF00': '黄',
    '00FF00': 'ライム',
    'AFEEEE': '青白い',
    'ADD8E6': 'スベルトブルー',
    'DDA0DD': '梅',
    'D3D3D3': 'ライトグレー',
    'FFF0F5': 'ピンクラベンダー',
    'FAEBD7': 'アンティークホワイト',
    'FFFFE0': '薄黄色',
    'F0FFF0': '甘露',
    'F0FFFF': '紺碧',
    'F0F8FF': '青白い',
    'E6E6FA': 'ラベンダー',
    'FFF': '白い'
  },
  more: 'より多くの色...',
  panelTitle: '色',
  textColorTitle: 'テキストの色'
} );



// WEBPACK FOOTER //
// ./src/app/editor/widget_initializers/wysiwyg/ckeditor/plugins/colortext/lang/ja.js